export type CalendarDate = { year: number; month: number; day: number };

export const SCHOOL_YEAR_START_MONTH = 7;

const LABEL = /^\s*(\d{4})\s*[-–]\s*(\d{2,4})/;

export function labelForStartYear(start: number): string {
  return `${start}-${String((start + 1) % 100).padStart(2, '0')}`;
}

export function labelForEndYear(end: number): string {
  return labelForStartYear(end - 1);
}

function toCalendarDate(date: CalendarDate | Date): CalendarDate {
  if (date instanceof Date) {
    return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() };
  }
  return date;
}

export function schoolYearEndForDate(date: CalendarDate | Date): number {
  const d = toCalendarDate(date);
  return d.month >= SCHOOL_YEAR_START_MONTH ? d.year + 1 : d.year;
}

export function schoolYearForDate(date: CalendarDate | Date): string {
  return labelForEndYear(schoolYearEndForDate(date));
}

export function clockSchoolYear(now: Date = new Date()): string {
  return schoolYearForDate(now);
}

export function schoolYearStartYear(label: string): number | null {
  const match = label.match(/^\s*(\d{4})/);
  return match ? Number(match[1]) : null;
}

export function schoolYearEndYear(label: string): number | null {
  const start = schoolYearStartYear(label);
  return start == null ? null : start + 1;
}

export function normalizeSchoolYear(label: string): string {
  const match = label.match(LABEL);
  if (match == null) return label.trim();
  return `${match[1]}-${(match[2] as string).slice(-2)}`;
}

export function priorSchoolYear(label: string): string {
  const start = schoolYearStartYear(label);
  return start == null ? label : labelForStartYear(start - 1);
}

export function nextSchoolYear(label: string): string {
  const start = schoolYearStartYear(label);
  return start == null ? label : labelForStartYear(start + 1);
}

export function displaySchoolYear(label: string): string {
  return `SY ${normalizeSchoolYear(label)}`;
}

export function shortSchoolYearLabel(label: string): string {
  const [start, end] = label.split('-');
  if (!start || !end) {
    return label;
  }
  return `‘${start.slice(-2)}–${end.slice(-2)}`;
}

export function formatSchoolYearShort(label: string | undefined): string {
  if (!label) return '';
  const parts = label.replace(/'/g, '').trim().split('-');
  if (parts.length !== 2) return '';
  const start = parts[0]?.slice(-2);
  const end = parts[1]?.slice(-2);
  if (!start || !end) return '';
  return `'${start}-${end}`;
}

export function shortLabelForEndYear(end: number): string {
  return `'${String(end - 1).slice(2)}-${String(end).slice(2)}`;
}
